export function minifyCssString(css: string) {
  return css
    .replace(/*JSBlockComments*/ /\/\*[\S\s]*?\*\//gm, '')
    .replace(/\n/g, '')
    .replace(/\s\s/g, '')
    .trim();
}
